import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import moment from 'moment';
import { DiscontinuousPermanentWorkersKpiCfg, DiscontinuousPermanentWorkersKpiCfgService } from "./discontinuousPermanentWorkersKpiCfg.service";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class DiscontinuousPermanentWorkersServiceData {
    public consultant: number;
    public office: number;
    public updateTimestamp: Date;
}

@Injectable()
export class DiscontinuousPermanentWorkersService extends KpiService<DiscontinuousPermanentWorkersServiceData> {
    public getClassName() { return "DiscontinuousPermanentWorkersService"; }

    constructor(
        private serviceCfg: DiscontinuousPermanentWorkersKpiCfgService,
        private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ) {
        super(injector);
    }

    protected async update(): Promise<DiscontinuousPermanentWorkersServiceData> {
        if (this.apigeeService.apiToken) {
            let result: DiscontinuousPermanentWorkersServiceData = null;
            try {
                let cfg: DiscontinuousPermanentWorkersKpiCfg = this.serviceCfg.getCfg();
                let currentDate = moment();
                let date: string = "{0}{1}{2}".format(String(currentDate.year()).padStart(4, "0"), String(currentDate.month() + 1).padStart(2, "0"), String(currentDate.date()).padStart(2, "0"))
                let url = cfg.discontinuousPermanentWorkers.summaryEndpointPattern.format(this.officeSelectorService.selectedOffice.id, date);
                result = await this.httpClient.get<DiscontinuousPermanentWorkersServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters, "KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
